<script setup lang="ts">
import type { PortableTextBlock } from '@sanity/types';
import FormFieldNotePortableText from './FormFieldNotePortableText.vue';

/**
 * FormFieldNote is used to display a text note on a form. It's most useful in a form builder setting,
 * when using a Dynamic Form and a form schema.
 */

const props = defineProps<{
  noteText?: string |  PortableTextBlock[];
}>();
</script>

<template>
  <div v-if="typeof props.noteText === 'string'">
    <p>{{ props.noteText }}</p>
  </div>
  <FormFieldNotePortableText v-else-if="props.noteText" :note-text="props.noteText" />
</template>
